import { POST } from "../../index";

export const selectCarState = (param) => POST("/v1/distribute/selectCarState", param);
export const selectCarLocationList = (param) => POST("/v1/distribute/selectCarLocationList", param);
